/**
 * En el registro el teléfono opcional se guarda en `personaResponsable`.
 * El formulario de perfil edita `contactoPublico`. Combina ambas fuentes
 * para que los inputs muestren lo que el usuario ya introdujo.
 */
export function mergeContactoPublicoForForm(contactoPublico, personaResponsable) {
  const cp = contactoPublico && typeof contactoPublico === 'object' ? contactoPublico : {};
  const pr = personaResponsable && typeof personaResponsable === 'object' ? personaResponsable : {};
  const pick = (primary, fallback) => {
    const s = (v) => (v == null ? '' : String(v).trim());
    return s(primary) || s(fallback) || '';
  };
  return {
    telefono: pick(cp.telefono, pr.telefono),
    email: pick(cp.email, pr.email),
    website: cp.website == null ? '' : String(cp.website).trim(),
  };
}
